import type { MasteryState } from '../engine/mastery';

/** Порядок обхода состояний. Он же порядок дуг в кольце и строк в легенде:
 *  от освоенного к невстреченному, чтобы взгляд слева направо читал
 *  «сколько сделано → сколько осталось». */
export const MASTERY_ORDER: readonly MasteryState[] = [
  'mastered',
  'slow',
  'erring',
  'insufficient',
  'never',
];

export const MASTERY_LABEL: Record<MasteryState, string> = {
  mastered: 'Освоено',
  slow: 'Разгонять',
  erring: 'Учить',
  insufficient: 'Данных мало',
  never: 'Не встречалось',
};

/** Цвет берётся переменной, а не литералом: та же переменная красит дугу
 *  кольца, точку легенды и плашку на экране примера (токены в styles.css). */
export const MASTERY_COLOR: Record<MasteryState, string> = {
  mastered: 'var(--color-mastered)',
  slow: 'var(--color-slow)',
  erring: 'var(--color-erring)',
  insufficient: 'var(--color-insufficient)',
  never: 'var(--color-never)',
};

/** Короткая подпись рядом с цветной меткой в списке примеров таблицы.
 *  Полная («Данных мало») не помещается в две колонки на телефоне, а совсем
 *  без подписи состояние остаётся только цветом — это §10 запрещает. */
export const MASTERY_SHORT: Record<MasteryState, string> = {
  mastered: 'освоено',
  slow: 'медленно',
  erring: 'ошибки',
  insufficient: 'мало данных',
  never: 'не было',
};

/** Пояснение к состоянию на экране одного примера. */
export const MASTERY_NOTE: Record<MasteryState, string> = {
  mastered: 'Отвечает быстро и уверенно, и не первый день',
  slow: 'Отвечает верно, но медленно — нужна скорость',
  erring: 'В последних попытках есть ошибки',
  insufficient: 'Замеров пока мало, чтобы судить',
  never: 'Этот пример ещё не встречался',
};
